import TicketNotification from './TicketNotification';
export default class StaffRepliedNotification extends TicketNotification {
  icon() {
    return 'fas fa-headset';
  }
  content() {
    return this.trans('staff_replied_text');
  }
}
flarum.reg.add('soup-97-support', 'forum/components/notifications/StaffRepliedNotification', StaffRepliedNotification);